import { render, staticRenderFns } from "./cBack.vue?vue&type=template&id=68e1429c&scoped=true"
import script from "./cBack.vue?vue&type=script&lang=js"
export * from "./cBack.vue?vue&type=script&lang=js"
import style0 from "./cBack.vue?vue&type=style&index=0&id=68e1429c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e1429c",
  null
  
)

export default component.exports